import React, { useEffect, useState } from 'react';
import './dashboard.css';
import homeIcon from './../../Constant/Icons/dashboard.svg';
import choiceIcon from './../../Constant/Icons/choice.svg';
import uploadIcon from './../../Constant/Icons/upload.svg';
import PInfo from './../../Constant/Icons/pInfo.svg';
import { useLocation, useNavigate } from 'react-router-dom';

function Sidebar({ onRouteChange, appStatus }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
    const location = useLocation();
    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Function to handle route changes, both from sidebar and other sources
    const handleRouteChange = (route) => {
        if (location.pathname !== route) {
            navigate(route);
            onRouteChange(route);
        }
    };

    useEffect(() => {
        setIsSidebarOpen(window.innerWidth >= 1024);
    }, [window.innerWidth])

    return (
        <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
            <button className="toggle-btn" onClick={toggleSidebar}>
                {isSidebarOpen ? '☰' : '☰'}
            </button>
            <ul>
                <li
                    onClick={() => handleRouteChange('/dashboard')}
                    className={location.pathname === '/dashboard' ? 'active' : ''}
                >
                    <img src={homeIcon} alt="Dashboard" width={20} height={20} />
                    {isSidebarOpen ? <span>Dashboard</span> : null}
                </li>
                {(appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderSpecialAllotment')?(  <></>):(appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderAllotment') ? (
                    <>
                        {/* <li
                            onClick={() => handleRouteChange('/dashboard/choicefilling')}
                            className={location.pathname === '/dashboard/choicefilling' ? 'active' : ''}
                        >
                            <img src={choiceIcon} alt="Upload" width={20} height={20} />
                            {isSidebarOpen ? <span>Choicefilling</span> : null}
                        </li> */}
                    </>
                ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderTentative') ? (
                    <>
                        {/* <li
                            onClick={() => handleRouteChange('/dashboard/choicefilling')}
                            className={location.pathname === '/dashboard/choicefilling' ? 'active' : ''}
                        >
                            <img src={choiceIcon} alt="Upload" width={20} height={20} />
                            {isSidebarOpen ? <span>Choicefilling</span> : null}
                        </li> */}
                    </>
                ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderChoicefilling') ? (
                    <>
                        <li
                            onClick={() => handleRouteChange('/dashboard/choicefilling')}
                            className={location.pathname === '/dashboard/choicefilling' ? 'active' : ''}
                        >
                            <img src={choiceIcon} alt="Upload" width={20} height={20} />
                            {isSidebarOpen ? <span>Choicefilling</span> : null}
                        </li>
                    </>
                ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderRank') ? (
                    <>
                        {/* <li
                            onClick={() => handleRouteChange('/dashboard/personalInfo')}
                            className={location.pathname === '/dashboard/personalInfo' ? 'active' : ''}
                        >
                            <img src={info} alt="Personal Info" width={20} height={20} />
                            {isSidebarOpen ? <span>Personal Info</span> : null}
                        </li> */}
          </>
        ) : (appStatus.submitStatus === "P" ||
            appStatus.submitStatus === "Y") &&
          appStatus.flag === "UnderCV" ? (
          <>
            {(appStatus.status === "Waiting" || appStatus.status === "Application under scrutiny")   && (
                <li
                  onClick={() =>
                    handleRouteChange("/dashboard/certificate-upload")
                  }
                  className={
                    location.pathname === "/dashboard/certificate-upload"
                      ? "active"
                      : ""
                  }
                >
                  <img src={uploadIcon} alt="Upload" width={20} height={20} />
                  {isSidebarOpen ? <span>Certificate Upload</span> : null}
                </li>
              )}

            {/* <li
                            onClick={() => handleRouteChange('/dashboard/personalInfo')}
                            className={location.pathname === '/dashboard/personalInfo' ? 'active' : ''}
                        >
                            <img src={info} alt="Personal Info" width={20} height={20} />
                            {isSidebarOpen ? <span>Personal Info</span> : null}
                        </li> */}
                    </>
                ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag == "rankNotAvailable") ? (
                    <></>
                )
                 : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') ? (
                    <>
                        <li
                            onClick={() => handleRouteChange('/dashboard/certificate-upload')}
                            className={location.pathname === '/dashboard/certificate-upload' ? 'active' : ''}
                        >
                            <img src={uploadIcon} alt="Upload" width={20} height={20} />
                            {isSidebarOpen ? <span>Certificate Upload</span> : null}
                        </li>
                    </>
                ) : (
                    <>
                        {/* <li
                            onClick={() => handleRouteChange('/dashboard/personalInfo')}
                            className={location.pathname === '/dashboard/personalInfo' ? 'active' : ''}
                        >
                            <img src={PInfo} alt="Personal Info" width={20} height={20} />
                            {isSidebarOpen ? <span>Personal Info</span> : null}
                        </li> */}
                    </>
                )}
            </ul>
        </div>
    );
}

export default Sidebar;
